import React from "react";
import TimeFormat from "./timeFormat/timeFormat";

export default function AboutAdvisor({ isAdvisorUser, campaign }) {
  return (
    <div className="caAnalyticsBar">
      <div className="caAnalyticsBarHeader">
        <h3 className="m-0">About the partner</h3>
      </div>
      <div className="advisoraboutOuter">
        <div className="advisoraboutInner">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.00004 14C10.3334 11.6 12.6667 9.45093 12.6667 6.8C12.6667 4.14903 10.5774 2 8.00004 2C5.42271 2 3.33337 4.14903 3.33337 6.8C3.33337 9.45093 5.66671 11.6 8.00004 14Z" stroke={isAdvisorUser ? "#494DA2" : "#2978b5"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8 8.6665C9.1046 8.6665 10 7.7711 10 6.6665C10 5.56194 9.1046 4.6665 8 4.6665C6.8954 4.6665 6 5.56194 6 6.6665C6 7.7711 6.8954 8.6665 8 8.6665Z" fill={isAdvisorUser ? "#494DA2" : "#2978b5"} />
          </svg>
          <p className="m-0">Singapore</p>
        </div>

        {/* <div className="advisoraboutInner">
          <img src="assets/img/advisorUser.svg" alt="" />
          <div className="advisorStars">
            <img src="/assets/img/grey-star.svg" alt="" />
            <img src="/assets/img/grey-star.svg" alt="" />
            <img src="/assets/img/grey-star.svg" alt="" />
            <img src="/assets/img/grey-star.svg" alt="" />
          </div>
          <p className="m-0">0.0</p>
        </div> */}

        <div className="advisoraboutInner pb-0">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 11.3333V8L9.66667 7M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z" stroke={isAdvisorUser ? "#494DA2" : "#2978b5"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <p className="m-0">Member since <TimeFormat time={campaign?.company?.createdAt} type={4} /> </p>
        </div>
      </div>
    </div>
  );
}
